import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onContentDropped = action('onContentDropped', event => ({
    event,
    owaType: 'contentDropped',
})) as OwaNovaActionUnion<'contentDropped'>;
